module.exports = __webpack_public_path__ + "static/media/shadow-attack-4.db175c42.png";